/**
 * The primitives' own words: the close and copy controls, the states and the status
 * names every surface shares and no one screen owns. A screen that needs its own wording
 * passes it in, as `label` does on Skeleton and RequestId; these are what is said when
 * nothing more particular has been.
 */
export const ui = {
  /** Every dialog's header control. It is the cancel: no dialog has a Cancel button. */
  close: 'Close',
  dismiss: 'Dismiss',
  copied: 'Copied',
  /** Names what failed and the way out, and does not apologise. */
  copyFailed: 'Copy failed. Select the text and copy it with the keyboard.',
  /** Announced when the typed phrase matches: the confirm button is now available. */
  phraseMatches: 'Phrase matches.',
  /** Uppercased by the label treatment, so it is written in prose. */
  requestId: 'Request id',
  copyRequestId: 'Copy request id',
  /** Field's marker on the exception: required is the default and carries none. */
  optional: 'optional',
  loading: 'Loading',
  done: '✓ Done',
  /** StatusBadge's words: the API's states, and only those. */
  status: {
    live: 'Live',
    revoked: 'Revoked',
    active: 'Active',
    pending: 'Pending deletion',
    primary: 'Primary',
    retained: 'Retained',
    retiring: 'Retiring',
  },
} as const;
